import { RouterProvider } from 'react-router';
import { router } from './routes';
import { captureReferralFromUrl } from './lib/referral';

// Read before the router renders so the code survives the wallet round trip.
captureReferralFromUrl();

function App() {
  return <RouterProvider router={router} />;
}

export default App;
